import _ from 'lodash';

// Boomer stuff
 //export const BOOMER_IMG_PATH = window.location.host.includes("localhost") ? '/img/boomer/avatar-items/' : 'https://boom-avatars.s3.eu-west-2.amazonaws.com/items/';
export const BOOMER_IMG_PATH = '/img/boomer/avatar-items/';
export const BOOMER_ITEM_ORDER = ['bottom', 'top', 'hair', 'accessory', 'pet'];
export const BOOMER_BODY_HEIGHT = 510;
export const BOOMER_ITEMS_BASE = 570;
export const BOOMER_ITEMS_TOP = -195;
export const BOOMER_MAX_HEIGHT = 765;
export const BOOMER_MAX_WIDTH = 753;
export const BOOMER_FALLBACK_DATA = {
    body: {
        body_id: 2
    },
    items: []
}

// Boomer Item Types
export const ACCESSORY = "accessory";
export const BODY = "body";
export const BOTTOM = "bottom";
export const HAIR = "hair";
export const PET = "pet";
export const TOP = "top";

// Saved legacy IDs are XML IDs; compare database IDs only for new items.
export const sameBoomerItem = (first, second) => {
    if (!first || !second) return false;
    if (first.xmlId || second.xmlId) {
        return Boolean(first.xmlId && second.xmlId) &&
            String(first.xmlId) === String(second.xmlId) &&
            first.type === second.type && first.gender === second.gender;
    }
    return Boolean(first.id && second.id) && String(first.id) === String(second.id);
};

export const sortItems = (wearing, owned, all) => {
    return _.map(all, item => {
        const wearingItem = isWearing(wearing, item);
        return {
            ...item,
            owned: _.find(owned, ownedItem => sameBoomerItem(ownedItem, item)) ? true : false,
            tile: wearingItem && wearingItem.tile ? wearingItem.tile : "1",
            wearing: wearingItem ? true : false,
            xOffset: item.gender === "female" ? item.xOffset - (item.type === "hair" ? 0 : 4) : item.xOffset
        }
    });
}

export const previewItem = (wearing, newItem) => {
    if (newItem.type === BODY) {
        return {
            ...wearing,
            body: {
                body_id: newItem.id
            }
        }
    }
    const wearingWithoutDuplicate = _.reject(wearing.items, ['type', newItem.type]);
    return {
        ...wearing,
        items: [
            ...wearingWithoutDuplicate,
            {
                ...newItem
            }
        ]
    };
}

export const previewTile = (wearing, newItem, tile) => {
    if (!_.find(wearing.items, item => sameBoomerItem(item, newItem))) {
        return {
            ...wearing,
            items: [
                ...wearing.items,
                {
                    ...newItem,
                    tile
                }
            ]
        }
    }
    return {
        ...wearing,
        items: _.map(wearing.items, item => {
            if (sameBoomerItem(item, newItem)) {
                return {
                    ...item,
                    tile
                }
            }
            return item
        })
    }
}

export const removeItem = (wearing, itemToRemove) => {
    return {
        ...wearing,
        items: _.reject(wearing.items, item => sameBoomerItem(item, itemToRemove))
    }
}

export const isWearing = (wearing, item) => {
    if (item.type === BODY) {
        return String(item.id) === String(wearing.body.body_id);
    }
    return _.find(wearing.items, wearingItem => sameBoomerItem(wearingItem, item));
}

// USER RANKS
export const RANK1 = 100;
export const RANK2 = 200;
